package com.ustadmobile.core.impl.appstate

enum class AppStateIcon {

    MOVE, CLOSE, DELETE,

}